<template>
  <div class="score">
    <div class="hero is-primary">
      <div class="hero-body" style="padding: 10px;">
        <div class="container">
          <h1 class="title is-size-1">Rankings 2.0</h1>    
          <h1 class="subtitle">Top 100 w/best 20 Solo YTD
            <span class="is-pulled-right is-size-5 has-text-right"><a v-on:click="showInfo()" class="info" title="Info"><i class="fas fa-info-circle"></i></a></span>
            <span class="is-pulled-right is-size-5 has-text-right"><a v-on:click="showDateOptions()" class="dates" title="Show Date Range"><i class="fas fa-calendar"></i></a></span>
          </h1>
          <div v-if="showDates" class="rankings-date-range">
            <div class="field is-horizontal" style="max-width: 600px;">
              <div class="field-body">
                <div class="field">
                  <div>Start</div>
                  <input class="input" type="date" v-model="startDate" style="width: 200px;"/> 
                </div>
                <div class="field">
                  <div>End</div>
                  <input class="input" type="date" v-model="endDate" style="width: 200px;"/>
                </div>
                <div class="field">
                  <button class="button is-primary" v-on:click="getScoreCards('Solo');">Go!</button> 
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="box" v-show="showError">
        <article class="message is-danger">
          <div class="message-body">
              {{ errorMessage }}
          </div>
        </article>
      </div>

      <div v-show="scorecards.length === 0 && pleaseWait">
        <div class="has-text-centered" style="background-color: #241d1e;">
          <br/>
          <br/>
          <img :src="`${publicPath}img/axes2_please_wait_rotating.gif`"/>
          <p style="font-family: inherit; color: #ffdd57; font-size: 0.9em;">Please wait, loading data...</p>
          <br/>
          <br/>
          <br/>
          <br/>
          <br/>
          <br/>
          <br/>
          <br/>
          <br/>
          <br/>
        </div>
      </div>

      <div v-show="!pleaseWait" class="box scorecards" style="margin-top: 20px;">
        <div v-show="scorecards.length === 0 && !pleaseWait">
            <p>No data yet available.</p>
        </div>
        <div v-show="scorecards.length !== 0">
          <div>
            <div v-for="(card, index) in scorecards" :key="card.display_name">

              <div class="box" style="background-color: #242424; color: white; padding-bottom: 5px; margin-bottom: 8px; border: 1px solid #444;">
                <div class="columns is-mobile">
                  <div class="column is-2">
                    <p class="is-size-3">
                      {{ (index+1) }}
                    </p>
                  </div>
                  <div class="column is-2">
                    <span v-if="card.country != null &&  card.country != ''">
                      <country-flag v-bind:country="card.country" size="big" :title="card.country" rounded/>
                    </span>
                  </div>
                  <div class="column is-5">
                    <p class="is-size-6" style="margin-left: 10px;">
                      {{ card.player }}
                    </p>
                  </div>
                  <div class="column is-3">
                    <p class="is-size-4">
                      Avg {{ card.average_score }}
                    </p>
                  </div>
                </div>
              </div>

              <div style="padding-bottom: 10px;">
                <div class="columns is-vcentered is-centered is-mobile">
                  <div class="column is-12">
                    <div class="box" style="background-color: #2c2c2c; margin-bottom: 20px; border: 1px solid #444;">
                      <div class="columns is-vcentered is-centered is-mobile">
                        <div class="column is-4" style="padding-top: 0px; padding-bottom: 0px;">
                          <p class="is-size-6">Date</p>
                        </div>
                        <div class="column is-2" style="padding-top: 0px; padding-bottom: 0px;">
                          <p class="is-size-6">Avg</p>
                        </div>
                        <div class="column is-2" style="padding-top: 0px; padding-bottom: 0px;">
                          <p class="is-size-6">Total</p>
                        </div>
                        <div class="column is-2" style="padding-top: 0px; padding-bottom: 0px;">
                        </div>
                        <div class="column is-2" style="padding-top: 0px; padding-bottom: 0px;">
                          <span v-if="card.showCards">
                            <a @click="toggleCards(card)"><i class="fas fa fa-angle-double-up"></i></a>
                          </span>
                          <span v-else>
                            <a @click="toggleCards(card)"><i class="fas fa fa-angle-double-down"></i></a>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="box" style="background-color: #333; padding-top: 0px; margin-bottom: 10px; border: 1px solid #555;"
                       v-if="card.showCards">
                      <div v-for="scorecard in card.scorecards" :key="scorecard._id">
                        <div class="columns is-vcentered is-centered is-mobile">
                          <div class="column is-4">
                            <p class="is-size-6">
                              {{ scorecard.dateTimeStamp | formatDateSmall }}
                            </p>
                          </div>
                          <div class="column is-2">
                            <a v-on:click="showScorecardById(scorecard.id)">
                              <p class="is-size-6">
                                <span class="scorecard-value">{{ scorecard.average }}</span>
                              </p>
                            </a>
                          </div>
                          <div class="column is-2">
                            <a v-on:click="showScorecardById(scorecard.id)">
                              <p class="is-size-6">
                                <span class="scorecard-value">{{ scorecard.total }}</span>
                              </p>
                            </a>
                          </div>
                          <div class="column is-2">
                            <a v-on:click="showScorecardById(scorecard.id)"><i class="fas fa-solid fa-bullseye"></i></a>
                          </div>
                          <div class="column is-2" style="padding-bottom: 1px; padding-top: 1px;">
                            <span v-if="scorecard.weather != null  && scorecard.weather.name != null && scorecard.weather.sys.country != null && scorecard.weather.weather[0].description != null && scorecard.weather.main.temp != null">
                              <img v-bind:src="'http://openweathermap.org/img/w/' + scorecard.weather.weather[0].icon + '.png'"
                                v-bind:title="scorecard.weather.name + ' ' + scorecard.weather.sys.country + ' ' + scorecard.weather.weather[0].description  + ' ' + (Math.round(scorecard.weather.main.temp)) + 'c'" 
                                style="height: 40px;"/> 
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br/>
    <br/>
    <br/>
    <br/>
  </div>
</template>

<script>
import axios from "axios";
import moment from 'moment';
import { GameType } from '@/enum/gameType.js';

export default {
  name: 'leaders',
    components : {
    },
    computed: {
    },
    data () {
        return {
            debugMode: (process.env.VUE_APP_DEBUG_MODE === "true" ? true : false),
            publicPath: process.env.BASE_URL,
            scorecards: [],
            options: {
                lettersCtn: 30,
                wrapperStyle: 'color: yellow;'
            },
            profiles: [],
            errorMessage: '',
            showError: false,
            pleaseWait: true,
            startDate: moment().startOf('year').format('YYYY-MM-DD'),
            endDate: moment().endOf('month').format('YYYY-MM-DD'),
            club: '',
            showDates: false
        }
    },
    methods:{
        toggleCards: function(card) {
            card.showCards = (card.showCards ? false : true);
        },
        showDateOptions: function() {
          this.showDates = !this.showDates;
        },
        showInfo: function() {
          this.$parent.showInfoModal();
        },
        showScorecard: function(scorecard) {
          this.$parent.showModal(scorecard);
        },
        showScorecardById: function(scorecard_id) {
          var url = (this.debugMode ? "http://localhost:8080/scorecard/" : "https://axes2api.azurewebsites.net/scorecard/")
          url += scorecard_id;

          var token = this.$parent.getApiToken();

          axios.get(url,{
              headers: {
                  authorization: token
              }
          })
          .then((response) => {
            this.$parent.showModal(response.data);
          }, (error) => {
            alert(error);
          });

        },
        getScoreCards: function (gameType) {
          var club = this.club;
          var url = (this.debugMode ? "http://localhost:8080/ranking2" : "https://axes2api.azurewebsites.net/ranking2")
              url += "/" + this.startDate + "/" + this.endDate + "/" + gameType;
          if (club != '') url += "/" + club;

          //console.log(url);

          axios.get(url)
            .then((response) => {
              if (response.data.error != null) {
                this.errorMessage = response.data.error;
                this.showError = true;
                this.pleaseWait = false;
              } else {

                var data = response.data;
                for (var i = 0; i < data.length; i++) {
                  data[i].showCards = false;
                }

                this.scorecards = response.data;
                this.pleaseWait = false;
              }
            }, (error) => {
              this.errorMessage = error;
              this.showError = true;
              this.pleaseWait = false;
            });
        },
    },
    mounted(){
      setTimeout(() => {
        this.getScoreCards("Solo");
      }, 1000);
    }
}

function Axes2Scorecards(user, averageThrow, totalThrows, totalBulls, scorecards, playerCountry, playerDisplayName) {
	this.user = user;
	this.averageThrow = averageThrow;
  this.totalThrows = totalThrows;
  this.totalBullseyes = totalBulls;
	this.scorecards = scorecards;
  this.showCards = false;
  this.playerCountry = playerCountry;
  this.playerDisplayName = playerDisplayName;
}
</script>

<style lang="scss" scoped>
.avg-throw-heading {
  padding: 10px;
  color: white;
}
.title {
  color: white !important;
}
.info {
  color: #e3fd9a;
}
.scorecards {
  font-family: inherit;
  background-color: #242424 !important;
}
.blink {
  font-family: verdana;
  color: #e08e11;
  animation: blink-animation 1s steps(5, start) infinite;
  -webkit-animation: blink-animation 1s steps(5, start) infinite;
}
@keyframes blink-animation {
  to {
    visibility: hidden;
  }
}
@-webkit-keyframes blink-animation {
  to {
    visibility: hidden;
  }
}
a {
  color: #4caf50;
  text-decoration: none;
  transition: color 0.2s;
}
a:hover {
  color: #ffdd57;
}
.box {
    background-color: #242424;
    color: white;
}
.hero {
  background-color: #2e7d32;
  margin-bottom: 20px;
}
.score {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  background-color: #181313;
  color: white;
  min-height: 100vh;
}
.scorecard-value {
    color: #ffdd57;
    font-weight: bold;
}

#leaderboard {
  width: 100%;
}

@media screen and (min-width: 600px) {
  .toggle-link {
    display: inline;
  }
  .leaderboard-main-mobile {
    display: none;
  }
}
</style>